module.exports = __webpack_public_path__ + "images/xyz2-02842dbffd30a36d590457af08bbae18.jpg";